import '../../App.css';

function SagaGym() {
  return (
    <div style={{
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      line游eight: '1.6',
      color: '#333'
    }}>
      <h1>Política de Privacidad y Términos de Servicio</h1>
      <p>Última actualización: 24 de agosto de 2026</p>
      <p>Esta Política de Privacidad y Términos y Condiciones describe nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de su información cuando utiliza la aplicación móvil de <strong>Saga Gym</strong>, así como las condiciones de uso de nuestros servicios y la gestión de membresías.</p>
      <p>Al utilizar nuestra aplicación móvil, usted acepta de conformidad los términos descritos en este documento.</p>

      <h2>1. Uso de la Aplicación y Datos</h2>
      <ul>
        <li>La aplicación móvil de <strong>Saga Gym</strong> recopila y procesa datos estrictamente necesarios para su funcionamiento, tales como el registro de tus avances físicos, marcas de entrenamiento e historial de asistencia.</li>
        <li>Los datos de tus rutinas son de uso exclusivo entre tú y tu entrenador asignado para garantizar la personalización y optimización de tu plan de entrenamiento.</li>
        <li>Nos comprometemos a proteger tu información y a no compartir tus marcas o datos personales con terceros sin tu consentimiento expreso.</li>
      </ul>

      <h2>2. Planes de Entrenamiento y Rutinas</h2>
      <ul>
        <li>Todas las rutinas de ejercicios visibles en la aplicación son creadas de forma personalizada por los entrenadores calificados de Saga Gym.</li>
        <li>El usuario es responsable de ejecutar los ejercicios siguiendo las instrucciones de su entrenador para evitar lesiones. Saga Gym no se responsabiliza por el mal uso de las instalaciones o la incorrecta ejecución de las rutinas de forma autónoma.</li>
        <li>Los planes de entrenamiento están sujetos a modificaciones por parte del entrenador según la evolución y objetivos del alumno.</li>
      </ul>

      <h2>3. Membresías, Pagos y Renovaciones</h2>
      <ul>
        <li>La aplicación permite visualizar el estado actual de tu membresía, fechas de vencimiento e historial de pagos.</li>
        <li>Todos los precios de los planes de entrenamiento están expresados en moneda local e incluyen los impuestos de ley vigentes.</li>
        <li>Los pagos de mensualidades o anualidades deben realizarse en los periodos establecidos para evitar la suspensión automática del acceso a las rutinas de la app y a las instalaciones del gimnasio.</li>
        <li>Las promociones, descuentos o tarifas corporativas especiales no son acumulables, salvo que se indique expresamente lo contrario.</li>
      </ul>

      <h2>4. Cancelaciones y Devoluciones</h2>
      <ul>
        <li>Las membresías contratadas son de carácter personal e intransferible.</li>
        <li>No se realizan reembolsos ni devoluciones de dinero por periodos de mensualidades ya iniciados o por la inasistencia del usuario a las instalaciones.</li>
        <li>En caso de suspensiones médicas justificadas, el usuario deberá presentar el certificado correspondiente en la recepción para evaluar la congelación temporal del plan.</li>
      </ul>

      <h2>5. Normas de Convivencia y Acceso</h2>
      <ul>
        <li>El acceso al gimnasio requiere contar con una membresía activa y al día en el sistema de pagos reflejado en la app.</li>
        <li>Es obligatorio el uso de vestimenta deportiva adecuada, calzado limpio y toalla personal para el uso de las máquinas por razones de higiene.</li>
        <li>Saga Gym se reserva el derecho de admisión o de rescindir la membresía de cualquier usuario que incumpla las normas de respeto y comportamiento dentro del establecimiento.</li>
      </ul>

      <h2>6. Limitación de Responsabilidad</h2>
      <ul>
        <li>El usuario declara estar en condiciones físicas óptimas para realizar actividad física. Se recomienda contar con una evaluación médica previa antes de iniciar cualquier plan de entrenamiento de alta intensidad.</li>
        <li>Saga Gym no se hace responsable por lesiones derivadas de condiciones médicas preexistentes no notificadas ni por la pérdida de objetos personales dentro de las instalaciones.</li>
      </ul>

      <h2>7. Atención al Cliente y Soporte</h2>
      <ul>
        <li>Si experimentas problemas con la visualización de tus rutinas, el registro de tus avances o necesitas aclarar dudas sobre tus pagos, puedes contactarnos a través de:</li>
        <li><strong>Teléfono / WhatsApp:</strong> 0981-704-604</li>
        <li><strong>Email de Soporte:</strong> soporte@sagagym.com</li>
        <li><strong>Dirección:</strong> Augusto Roa Bastos 441, Asunción 001530</li>
      </ul>
    </div>
  );
}

export default SagaGym;
